import { storeToRefs } from 'pinia'
import { useAuthenticationStore } from '@cplug/frontend-shared-domains/domain/authentication'
import { useRuntimeConfig } from '#app'
import type { ExtendedCPlugAPI } from '~/global/types/runtime-config'
import { useBrandStore } from '~/domain/shared/branding/stores/useBrandStore'
import { useLegacyBridgeToken } from '~/shared/composables/useLegacyBridgeToken'

function normalizeBaseUrl (url: string): string {
  return url.replace(/\/+$/, '')
}

function resolveLegacyBaseUrl (cplugAPI: ExtendedCPlugAPI): string {
  const { isPartnerBrand } = storeToRefs(useBrandStore())

  return normalizeBaseUrl(isPartnerBrand.value ? cplugAPI.baseTrayURL : cplugAPI.baseCplugURL)
}

async function resolveAccessToken (cplugAPI: ExtendedCPlugAPI, companyId?: number): Promise<string> {
  const authStore = useAuthenticationStore()
  const { resolveLegacyAccessToken } = useLegacyBridgeToken()

  return await resolveLegacyAccessToken(
    cplugAPI.baseURL,
    companyId,
    cplugAPI.withCredentials === true,
    authStore.token
  )
}

export async function openLegacySSO (module: string): Promise<void> {
  const cplugAPI = useRuntimeConfig().public.cplugAPI as ExtendedCPlugAPI
  const authStore = useAuthenticationStore()
  const companyId = authStore.companies[0]?.id

  if (!companyId) {
    return
  }

  const accessToken = await resolveAccessToken(cplugAPI, companyId)

  if (!accessToken) {
    return
  }

  const legacyBaseUrl = resolveLegacyBaseUrl(cplugAPI)
  const url = new URL(`${legacyBaseUrl}/sso/${module}`)
  url.searchParams.set('access_token', accessToken)
  url.searchParams.set('company_id', String(companyId))

  window.open(url.toString(), '_blank')
}

export async function openLegacySistemaHome (): Promise<void> {
  const cplugAPI = useRuntimeConfig().public.cplugAPI as ExtendedCPlugAPI
  const authStore = useAuthenticationStore()
  const companyIds = authStore.companies.map(c => c?.id ?? '').filter(Boolean).join(',')

  if (!companyIds) {
    return
  }

  const accessToken = await resolveAccessToken(cplugAPI, authStore.companies[0]?.id)

  if (!accessToken) {
    return
  }

  const legacyBaseUrl = resolveLegacyBaseUrl(cplugAPI)
  const url = new URL(`${legacyBaseUrl}/sistema`)
  url.searchParams.set('access_token', accessToken)
  url.searchParams.set('company_id', companyIds)

  window.location.href = url.toString()
}
